'use client';

import { useSearchParams } from 'next/navigation';
import { Link } from '@/navigation';
import { LinkProps } from 'next/link';

interface LinkWithParametersProps extends LinkProps {
  country: string;
  vertical: string;
  children: React.ReactNode;
  className?: string;
  // Preenche o [slug] de um href nomeado, para o next-intl gerar o caminho traduzido.
  slug?: string;
}

export default function LinkWithParameters({
  href,
  children,
  country,
  vertical,
  className,
  slug,
}: LinkWithParametersProps) {
  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams.toString());

  if (!params.has('country')) params.set('country', country);
  if (!params.has('vertical')) params.set('vertical', vertical);

  const pathname = href.toString();
  const query = params.toString();

  return (
    <Link
      href={{ pathname, query, ...(slug && { params: { slug } }) } as any}
      className={className}>
      {children}
    </Link>
  );
}
